module.exports = __webpack_public_path__ + "static/infected-cell-3c4c3ba976f23c72b3c8c060d2a87195.svg";